import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Marathons/Lectures';

const { displayName } = config;

export default function MarathonLectures(): React.ReactNode | null {
  document.title = `${displayName}: Редактировать лекции`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}
